export default [
    {
        name: "plus",
        path: "/plus",
        component: () => import("@/views/Plus"),
    },
];
